import { getBucketing } from "../config/load";
import {
  type BucketingProvider,
  experimentBucketProvider,
  labradorBucketProvider,
  type WindowWithFandomContext,
} from "../bucketing";
import type { BucketingSource, InstantConfigGroup } from "../config/types";

export type BucketingMatcherSelector = (
  bucketingSource: BucketingSource,
) => BucketingMatcher;
export type BucketingMatcher = (group: InstantConfigGroup) => BucketingResult;
export type BucketingResult =
  | {
      isActive: boolean;
      defaultKeyVal: string;
      keyVal?: string;
    }
  | undefined;

export const bucketingMatcher = (
  bucketingProvider: BucketingProvider,
): BucketingMatcher => {
  return (group: InstantConfigGroup) => {
    const bucketing = getBucketing(group);

    if (!bucketing?.rules?.ranges) return undefined;

    const currentBucket: number = Math.round(bucketingProvider());
    const matchedRange = bucketing.rules.ranges.find(
      (range) => currentBucket >= range.start && currentBucket <= range.end,
    );

    return {
      isActive: !!matchedRange,
      defaultKeyVal: bucketing.rules.defaultKeyValue,
      keyVal: matchedRange?.keyValue,
    };
  };
};

export function getBucketingMatcherSelector(
  container: WindowWithFandomContext,
): BucketingMatcherSelector {
  return (bucketingSource: BucketingSource) => {
    switch (bucketingSource) {
      case "eb":
        return bucketingMatcher(labradorBucketProvider(container));
      case "exp_bucket":
        return bucketingMatcher(experimentBucketProvider);
      default:
        throw new Error(`Unknown bucketing source: ${bucketingSource}`);
    }
  };
}
